import  React, { useRef } from "react"
import ReactDOM from 'react-dom';

 const Portal = ({children,targetElementId}) => {
    const el = useRef(document.getElementById(targetElementId));
    const modalElement = document.createElement('div');
    return ReactDOM.createPortal(children, el.current || modalElement);
}

export {Portal}